import { Box, IconButton, Stack, Toolbar, Tooltip, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link as RouterLink } from 'react-router-dom';
import { SidebarNav } from './SidebarNav';
import { useUiStore } from '@/store/uiStore';
import { env } from '@/config/env';
import { paths } from '@/routes/paths';

interface SidebarProps {
  collapsed: boolean;
  onNavigate?: () => void;
  showCollapseToggle?: boolean;
}

/** Sidebar contents (brand header + navigation). Shared by desktop + mobile drawers. */
export function Sidebar({ collapsed, onNavigate, showCollapseToggle = true }: SidebarProps) {
  const toggleSidebar = useUiStore((s) => s.toggleSidebar);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Toolbar
        disableGutters
        sx={{ px: collapsed ? 1 : 2, justifyContent: 'space-between', minHeight: 64 }}
      >
        <Stack
          component={RouterLink}
          to={paths.dashboard}
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ textDecoration: 'none', color: 'inherit', overflow: 'hidden' }}
        >
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: 1.5,
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              display: 'grid',
              placeItems: 'center',
              fontWeight: 800,
              flexShrink: 0,
            }}
          >
            A
          </Box>
          {!collapsed && (
            <Typography variant="subtitle1" fontWeight={800} noWrap>
              {env.appName}
            </Typography>
          )}
        </Stack>
        {showCollapseToggle && (
          <Tooltip title={collapsed ? 'Expand' : 'Collapse'}>
            <IconButton
              size="small"
              onClick={toggleSidebar}
              sx={{ display: { xs: 'none', lg: 'inline-flex' } }}
              aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            >
              {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>
      <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
        <SidebarNav collapsed={collapsed} onNavigate={onNavigate} />
      </Box>
    </Box>
  );
}
